module.exports = __webpack_public_path__ + "img/fou-terroir-packaging.2cab843.jpg";